import intl from 'react-intl-universal';
import { getMessages, getSupportedLocale } from '../_locales/_helper';
import * as  types from './types';

export const setLocale = (callback) => {
    const locale = getSupportedLocale(intl.determineLocale());
    console.log(getMessages(locale))
    return function (dispatch) {
        intl.init({
            currentLocale: locale,
            locales: {
                [locale]: getMessages(locale)
            }
        })
            .then(() => {
                if (callback !== undefined) {
                    callback();
                }
                dispatch({ type: types.SET_LOCALE, payload: locale })
            }) 
    }

}